// src/pages/ThankYou.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="thank_you_page">
      <h2>Thank you for booking our service</h2>
      <p>If you have any questions, please feel free to contact us by phone or email.</p>
      <button className="home_btn" onClick={() => navigate('/')}>Go to Home</button>
    </div>
  );
};

export default ThankYou;
